import { render, staticRenderFns } from "./baseFoundation.vue?vue&type=template&id=8d39fd72&scoped=true"
import script from "./baseFoundation.vue?vue&type=script&lang=js"
export * from "./baseFoundation.vue?vue&type=script&lang=js"
import style0 from "./baseFoundation.vue?vue&type=style&index=0&id=8d39fd72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d39fd72",
  null
  
)

export default component.exports